import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { api, apis, apiHolder } from 'api';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import MainReadMail from './components/MainReadMail/MainReadMail';
import useState2RM from './hooks/useState2ReduxMock';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
import { actions as mailTabActions, tabId, tabType } from '@web-common/state/reducer/mailTabReducer';
import { transContactModel2ContactItem } from '@web-common/components/util/contact';
import { CollapsibleList } from '@web-common/components/UI/CollapsibleList';
import { useState2CustomerSlice, useState2SubordinateSlice } from './hooks/useState2SliceRedux';
import { LIST_MODEL } from './common/constant';
import RightSidebar, { RightSidebarScene } from './rightSidebar';
import { DEFAULT_CUSTOMER_WIDTH, DEFAULT_READ_MAIL_MIN_WIDTH } from '@web-mail/hooks/useAppScale';
import { getCustomerSliceIdByType } from '@web-mail/utils/slice';
const systemApi = api.getSystemApi();
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const eventApi = api.getEventApi();
const { isMac } = apiHolder.env;
import useConditionalMemo from '@web-common/hooks/useConditionalMemo';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import useUserLocalStorageState from '@web-mail/hooks/useUserLocalStorageState';
const COLUMN_READ_TAB_SHOW_SIDER = 'COLUMN_READ_TAB_SHOW_SIDER';
export const RightSider = process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG
    ? props => {
        const { id, maxWidth, lock } = props || {};
        const [hasShow, setHasShow] = useUserLocalStorageState(COLUMN_READ_TAB_SHOW_SIDER, true);
        const [rightSideSelectedDetail, setRightSideSelectedDetail] = useState2RM('rightSideSelectedDetail');
        const [mailEntities] = useState2RM('mailEntities');
        const [configMailLayout] = useState2RM('configMailLayout');
        const [sidebarFold, setSidebarFold] = useState(false);
        const currentMail = useMemo(() => (id ? mailEntities[id] : null), [mailEntities, id]);
        const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
        const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
        const isCustomerTab = useMemo(() => currentTabType === tabType.customer, [currentTabType]);
        const isSent = useMemo(() => {
            var _a, _b, _c;
            if (currentMail) {
                const accountAlias = ((_b = (_a = systemApi.getCurrentUser(currentMail === null || currentMail === void 0 ? void 0 : currentMail._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
                const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
                const senderEmail = contactApi.doGetModelDisplayEmail((_c = currentMail === null || currentMail === void 0 ? void 0 : currentMail.sender) === null || _c === void 0 ? void 0 : _c.contact);
                return (accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) ||
                    accountApi.getIsSameSubAccountSync(senderEmail, currentMail._account));
            }
            else {
                return false;
            }
        }, [currentMail]);
        const replyToMail = useMemo(() => {
            const replyToMails = (currentMail === null || currentMail === void 0 ? void 0 : currentMail.headers) && (currentMail === null || currentMail === void 0 ? void 0 : currentMail.headers['Reply-To']);
            const reply = (replyToMails === null || replyToMails === void 0 ? void 0 : replyToMails.length) && replyToMails[0];
            if (reply && reply.trim()) {
                return reply;
            }
            return undefined;
        }, [currentMail]);
        const dispatch = useAppDispatch();
        const { productVersionInfo: { productVersionId, navigateVersion }, } = useGetProductAuth();
        const asideContactProp = useMemo(() => currentMail === null || currentMail === void 0 ? void 0 : currentMail.sender, [currentMail]);
        useEffect(() => {
            var _a, _b, _c;
            if (!currentMail || !isSent) {
                setRightSideSelectedDetail({ email: '', name: '' });
            }
            else {
                const toContact = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) === null || _a === void 0 ? void 0 : _a.find(c => c.mailMemberType === 'to' && !!contactApi.doGetModelDisplayEmail(c.contact));
                const ccContact = (_b = currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) === null || _b === void 0 ? void 0 : _b.find(c => c.mailMemberType === 'cc');
                const bccContact = (_c = currentMail === null || currentMail === void 0 ? void 0 : currentMail.receiver) === null || _c === void 0 ? void 0 : _c.find(c => c.mailMemberType === 'bcc');
                const selectedContact = toContact || ccContact || bccContact;
                setRightSideSelectedDetail({ email: contactApi.doGetModelDisplayEmail(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.contact), name: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.originName) || '' });
            }
        }, [currentMail, isSent]);
        const sliceIdSd = useMemo(() => {
            let id = currentTabId;
            if (currentTabType !== tabType.subordinate) {
                id = tabId.subordinate;
            }
            return id;
        }, [currentTabId, currentTabType]);
        const selectedCustomerTab = useAppSelector(state => state.mailReducer.selectedCustomerTab);
        const sliceIdCm = useMemo(() => getCustomerSliceIdByType(selectedCustomerTab), [selectedCustomerTab]);
        const customerAsideDetail = useAppSelector(state => {
            const isCustomerTab = state.mailTabReducer.currentTab.type === tabType.customer;
            if (isCustomerTab) {
                return state.mailReducer.customer[sliceIdCm].customerAsideDetail;
            }
            return state.mailReducer.customerAsideDetail;
        });
        const isLeftRight = useMemo(() => configMailLayout === '1', [configMailLayout]);
        const isColumnLayout = useMemo(() => configMailLayout === '2', [configMailLayout]);
        const handleColumnShow = useCallback((show) => {
            if (isColumnLayout && currentTabType === tabType.read) {
                setHasShow(show);
            }
        }, [isColumnLayout, currentTabType]);
        const [listModel] = useState2RM('defaultMailListSelectedModel', 'doUpdateMailListSelectedModel');
        const [listModelCm] = useState2CustomerSlice('defaultMailListSelectedModel', undefined, sliceIdCm);
        const [listModelSd] = useState2SubordinateSlice('defaultMailListSelectedModel', undefined, sliceIdSd);
        const logicListModel = useMemo(() => {
            if (currentTabType == tabType.customer) {
                return listModelCm;
            }
            if (currentTabType == tabType.subordinate) {
                return listModelSd;
            }
            return listModel;
        }, [listModel, listModelCm, listModelSd, currentTabType]);
        const asideEmail = useMemo(() => {
            if (rightSideSelectedDetail.email) {
                return rightSideSelectedDetail.email;
            }
            if (isCustomerTab) {
                return customerAsideDetail.email;
            }
            if (asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp.contact) {
                return contactApi.doGetModelDisplayEmail(asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp.contact);
            }
            return '';
        }, [isCustomerTab, customerAsideDetail.email, asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp.contact, rightSideSelectedDetail.email]);
        const showAside = useMemo(() => {
            if (!!lock) {
                return true;
            }
            if (!process.env.BUILD_ISEDM && !process.env.BUILD_ISLINGHANG) {
                return false;
            }
            if (process.env.BUILD_ISLINGHANG && !navigateVersion) {
                return false;
            }
            if (logicListModel == LIST_MODEL.MULTIPLE && isLeftRight) {
                return false;
            }
            if (isCustomerTab) {
                return !!(customerAsideDetail === null || customerAsideDetail === void 0 ? void 0 : customerAsideDetail.email);
            }
            if (!currentMail) {
                return false;
            }
            if (!asideEmail) {
                return false;
            }
            if (currentMail.isTpMail) {
                return false;
            }
            return true;
        }, [currentMail, customerAsideDetail.email, isCustomerTab, asideEmail, logicListModel, isLeftRight, lock, navigateVersion]);
        useEffect(() => {
            var _a;
            if (showAside && id && !sidebarFold && asideContactProp) {
                try {
                    const cardType = (_a = transContactModel2ContactItem(asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp.contact)) === null || _a === void 0 ? void 0 : _a.customerRole;
                    trackApi.track('waimao_mail_sidebar_appear', { cardType });
                }
                catch (e) {
                    console.log(e);
                }
            }
        }, [showAside, id, sidebarFold]);
        useEffect(() => {
            if (showAside && !sidebarFold) {
                dispatch(mailTabActions.doChangeMailSidebar(true));
            }
            else {
                dispatch(mailTabActions.doChangeMailSidebar(false));
            }
        }, [showAside, sidebarFold]);
        const asideRef = useRef();
        useEffect(() => {
            if (showAside) {
                setTimeout(() => {
                    var _a, _b, _c, _d;
                    if (isColumnLayout && (systemApi.inEdm() || navigateVersion)) {
                        if (currentTabType === tabType.customer || currentTabType === tabType.readMain) {
                            ((_a = asideRef === null || asideRef === void 0 ? void 0 : asideRef.current) === null || _a === void 0 ? void 0 : _a.controlAsideVisible) && ((_b = asideRef === null || asideRef === void 0 ? void 0 : asideRef.current) === null || _b === void 0 ? void 0 : _b.controlAsideVisible(false));
                        }
                        else if (currentTabType === tabType.read) {
                            ((_c = asideRef === null || asideRef === void 0 ? void 0 : asideRef.current) === null || _c === void 0 ? void 0 : _c.controlAsideVisible) && ((_d = asideRef === null || asideRef === void 0 ? void 0 : asideRef.current) === null || _d === void 0 ? void 0 : _d.controlAsideVisible(!!hasShow));
                        }
                    }
                }, 0);
            }
        }, [isColumnLayout, currentTabType, showAside]);
        const Element = useConditionalMemo(() => {
            return showAside ? (React.createElement(CollapsibleList, { ref: asideRef, defaultVisible: isColumnLayout && (systemApi.inEdm() || navigateVersion) && currentTabType === tabType.read ? !!hasShow : undefined, title: "\u4FA7\u8FB9\u680F", needBtn: true, placement: "right", resizable: false, style: { zIndex: 100 }, defaultWidth: DEFAULT_CUSTOMER_WIDTH, minConstraints: [DEFAULT_CUSTOMER_WIDTH, Infinity], maxConstraints: [350, Infinity], onOpen: () => {
                    setSidebarFold(false);
                    handleColumnShow(true);
                    trackApi === null || trackApi === void 0 ? void 0 : trackApi.track('pcMail_click_open_sidebar_readmail');
                }, onClose: () => {
                    setSidebarFold(true);
                    handleColumnShow(false);
                    trackApi === null || trackApi === void 0 ? void 0 : trackApi.track('pcMail_click_close_sidebar_readmail');
                } },
                React.createElement(RightSidebar, { scene: RightSidebarScene.EmailPlus, email: asideEmail || '', name: rightSideSelectedDetail.name || (asideContactProp === null || asideContactProp === void 0 ? void 0 : asideContactProp.originName), replyToMail: replyToMail, id: id, _account: currentMail === null || currentMail === void 0 ? void 0 : currentMail._account, needGlobalSearch: !isSent }))) : (React.createElement(React.Fragment, null));
        }, [RightSidebarScene.EmailPlus, asideEmail, showAside, rightSideSelectedDetail, replyToMail, id, currentMail === null || currentMail === void 0 ? void 0 : currentMail._account, handleColumnShow], !!lock);
        return Element;
    }
    : _ => React.createElement(React.Fragment, null);
const MainReadMailWrap = props => {
    const { showReadMail, height, id, from, openInNewWindow, readOnly, getSignMailContent, tempContent } = props || {};
    const style = useMemo(() => {
        return Object.assign(Object.assign({ height, position: 'relative', overflow: 'hidden', display: showReadMail ? 'block' : 'none', flex: '1 0', width: 0, minWidth: process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG ? 408 : DEFAULT_READ_MAIL_MIN_WIDTH }, (process.env.BUILD_ISLINGXI && process.env.BUILD_ISWEB ? { height: '100%' } : {})), (!isMac && (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) ? { zIndex: 5 } : {}));
    }, [showReadMail]);
    return (React.createElement(ErrorBoundary, { name: "readMailPage", extraInfo: {
            id,
            from,
            openInNewWindow,
            readOnly,
            isTpMail: !!getSignMailContent,
            tempContentId: tempContent === null || tempContent === void 0 ? void 0 : tempContent.id,
        } },
        React.createElement("div", { className: "mainreadmail-wrap", hidden: !showReadMail },
            React.createElement("div", { style: style },
                React.createElement(MainReadMail, Object.assign({}, props))))));
};
export default MainReadMailWrap;
